/**************************************************
 * Nombre:       Seccion_Detalle_Coleccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Coleccion_Titulo_Imgs from "./Componentes/Detalle_Coleccion_Titulo_Imgs";
import Lista_Productos from "./Componentes/Lista_Productos";
import Home_Categorias from "./Componentes/Home_Categorias";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {collection, orderBy, query, where} from "firebase/firestore";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {irArriba} from "../../Utilidades/irArriba";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";

const Seccion_Detalle_Coleccion = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [coleccion, setColeccion] = useState({})
    const [productos, setProductos] = useState([])

    useEffect(() => {

        irArriba()

        if (parms && parms.id) {

            obtenerDoc('colecciones', parms.id).then((dox) => {
                if (dox.res) {
                    setColeccion(dox.data)
                }
            })


            let q = query(collection(fire, 'productos'), where('idColeccion', '==', parms.id), orderBy('tipo', 'asc'))

            obtenerColeccionQuery(q).then((dox) => {
                if (dox.res) {
                    setProductos(dox.data)
                }
            })


        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Detalle_Coleccion_Titulo_Imgs coleccion={coleccion}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 4 : 8}}>
                <Lista_Productos productos={productos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 16, mb: sCell ? 8 : 16}}>
                <Home_Categorias/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle_Coleccion